<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <div v-if="!pageloading">
      <!-- title  -->
      <h2 class="mb-1">{{ getTitle }}</h2>
      <v-row class="mb-0 pb-0">
        <v-col cols="12" md="12">
          <el-simple-table :items="tebleItems" />
        </v-col>
        <v-col cols="12" md="12">
          <h2 class="mb-1">{{ $t('Objekto dokumentai / pranešimai') }}</h2>
          <!-- table -->
          <v-data-table
            class="mb-4 custom-table sticky-header-sav"
            :header-props="{
              sortByText: $t('Rūšiuoti pagal'),
            }"
            :items-per-page="-1"
            :loading="loading"
            :headers="filteredHeader"
            :items="formData.history_journals"
            hide-default-footer
          >
           <template #[`item.in_journal_type`]="{ item }">
              <el-table-enum enumName="historyType" :item="item.in_journal_type" />
            </template>
            <template #[`item.status`]="{ item }">
              <el-table-enum enumName="historyStatus" :item="item.status" />
            </template>
            <!-- custom templates -->
            <template #[`item.actions`]="{ item }">
              <div class="nowrap">
                <el-table-action 
                @downloadItem="download(item)"
                :item="setItemParam(item)" />
              </div>
            </template>
            <!-- basic templates -->
            <template slot="loading"> {{ $t('Kraunasi...') }} </template>
            <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
            <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
            <template #[`footer.page-text`]="props">
              {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
              {{ $t('iš') }}
              {{ props.itemsLength }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row class="mb-0 pb-0">
        <v-col>
          <statement-files
            :objectId="formData.id"
            :canChange="false"
          />
        </v-col>
      </v-row>
        <!-- actions  -->
    <v-card-actions>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <el-button
          tile
          icon="atgal"
          @click.native="back()"
          :loading="loading"
          title="Atgal"
        />
      </v-row>
    </v-card-actions>
    </div>
  </v-container>
</template>

<script>
import math from '@/mixins/math'
import StatementFiles from '@/components/tables/StatementFiles.vue'

export default {
  name: 'ObjectDataChangeForm',
  components: {
    StatementFiles
  }, 
  mixins: [ math ],
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
    }
  },
  computed: {
    getTitle() {
      return `${this.getObjectNo} ${this.$t('Objekto informacija')}`
    },
    getObjectNo() {
      return this.formData.mandate_code
    },
    getId() {
      return this.$route.params.id || null
    },
    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Registracijos Nr. dokumentų žurnale'),
          align: 'start',
          value: 'journal_no',
        },
        {
          text: this.$t('Pranešimo data ir laikas'),
          align: 'start',
          value: 'received_at',
        },
        {
          text: this.$t('Pranešimas / Dokumentas'),
          align: 'start',
          value: 'in_journal_type',
        },
        {
          text: this.$t('Registravimo data'),
          align: 'start',
          value: 'solved_at',
        },
        {
          text: this.$t('Būsena'),
          align: 'start',
          value: 'status',
        },
        {
          text: this.$t('Gavėjas'),
          align: 'start',
          value: 'received_by',
        },
        {
          text: this.$t('Sprendimą priemė'),
          align: 'start',
          value: 'solved_by',
        },
      ]
    },
    tebleItems() {
      return [
        {
          title: this.$t('Objekto tipas'),
          enumName: 'objectType',
          value: this.formData.mandate_kind || '',
        },
        {
          title: this.$t('Objekto ID'),
          value: this.formData.mandate_code || '',
        },
        {
          title: this.$t('Notarinio reg Nr.'),
          value: this.formData.notarial_no || '',
        },
        {
          title: this.$t('Objekto būsena'),
          enumName: 'mandateStatus',
          value: this.formData.status || '',
        },
        {
          title: this.$t('Išregistravimo data'),
          value: this.formData.deregistration_date || '',
          hide: !this.formData.deregistration_date,
        },
      ]
    },
  },
  created() {
    this.getData()
  },
  methods: {
    back() {
      this.$router.push({ name: 'adminObjectDataChange' })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`mandates/${this.getId}`)
        .then((res) => {
          this.formData = res.data.mandate
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    setItemParam(item) {
      return item
    },
  },
}
</script>

<style>
</style>